export default __webpack_public_path__ + "locales/ja-JP/Article.json?hash=adac204589d6fa5ceb831bd167db8878";